//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sync, call } from "vuex-pathify"
import Tags from '@/api/promotores/tags.api'
import ProductosApi from "@/api/promotores/productos.api";

export default {
  data() {
    return {
      tags: [],
      productos: [],
      estatuses: [
        { label: "Activo", icon: "check_circle", value: "activo" },
        { label: "Pendiente", icon: "pending", value: "pendiente" },
        { label: "Revisión Manual", icon: "remove_red_eye", value: "manual" },
        { label: "Desactivado", icon: "unpublished", value: "desactivado" },
      ],
      loading: false,
    }
  },
  computed: {
    show_drawer: sync("app/show_drawer"),

    tareas_expanded: sync('app/drawer_sections@tareas_expanded'),
    alianzas_expanded: sync('app/drawer_sections@alianzas_expanded'),
    aula_expanded: sync('app/drawer_sections@aula_expanded'),
    etiquetas_expanded: sync('app/drawer_sections@etiquetas_expanded') 
  },
  mounted() {
    this.loadTags()
    this.cargarProductos()
  },

  methods: {
    logout: call("auth/logout"),
    search: call("app/search"),

    async loadTags() {
      try {
        this.loading = true
        this.tags = await Tags.all()
      } finally {
        this.loading = false
      }
    },

    addTag() {
      this.$q
        .dialog({
          title: "Crear etiqueta",
          prompt: {
            model: "",
            type: "text", // optional
            label: "Nombre",
            outlined: true,
          },
          cancel: true,
        })
        .onOk(async (nombre) => {
          await Tags.add({ nombre })
          this.loadTags()
        })
    },

    updateTag({ nombre, id, slug }) {
      this.$q
        .dialog({
          title: "Modificar etiqueta",
          prompt: {
            model: nombre,
            type: "text", // optional
            label: "Nombre",
            outlined: true,
          },
          cancel: true,
        })
        .onOk(async (nombre) => {
          await Tags.update(id, { nombre, slug })
          this.loadTags()
        })
    },

    deleteTag(tag) {
      this.$q
        .dialog({
          title: "Eliminar etiqueta",
          message: `¿Seguro que quieres eliminar la etiqueta <b>${tag.nombre}</b>?`,
          html: true,
          cancel: true,
        })
        .onOk(async () => {
          await Tags.delete(tag.id)
          this.loadTags()
        })
    },

    async cargarProductos(){
      const response = await ProductosApi.all();
      this.productos = response.length ? response : []
    }
  },
}
